import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { Home, ChevronLeft, ChevronRight, X } from 'lucide-react';

const GlobalNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const canGoBack = window.history.length > 1;
  const canGoForward = window.history.state?.idx < window.history.length - 1;
  const isHomePage = location.pathname === '/';

  const handleClose = () => {
    // If in a modal context or can go back, go back. Otherwise go home.
    if (canGoBack) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  const handleHome = () => {
    navigate('/');
  };

  const handleBack = () => {
    if (canGoBack) {
      navigate(-1);
    }
  };

  const handleForward = () => {
    if (canGoForward) {
      navigate(1);
    }
  };

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 md:bottom-auto md:top-20 md:left-6 md:translate-x-0">
      <div className="flex items-center gap-2 bg-card/95 backdrop-blur-xl border border-border rounded-full px-2 py-1.5 shadow-lg">
        <Button
          variant="ghost"
          size="icon"
          onClick={handleClose}
          className="h-9 w-9 rounded-full hover:bg-destructive/10 hover:text-destructive"
          title="Fermer"
          data-testid="nav-close"
        >
          <X className="h-4 w-4" />
        </Button>
        
        <div className="w-px h-6 bg-border" />
        
        <Button
          variant="ghost"
          size="icon"
          onClick={handleHome}
          disabled={isHomePage}
          className="h-9 w-9 rounded-full"
          title="Accueil"
          data-testid="nav-home"
        >
          <Home className="h-4 w-4" />
        </Button>
        
        <div className="w-px h-6 bg-border" />
        
        <Button
          variant="ghost"
          size="icon"
          onClick={handleBack}
          disabled={!canGoBack}
          className="h-9 w-9 rounded-full"
          title="Page précédente"
          data-testid="nav-back"
        >
          <ChevronLeft className="h-4 w-4" />
        </Button>
        
        <Button
          variant="ghost"
          size="icon"
          onClick={handleForward}
          disabled={!canGoForward}
          className="h-9 w-9 rounded-full"
          title="Page suivante"
          data-testid="nav-forward"
        >
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default GlobalNavigation;
